const internals = {};

internals.path = `${process.env.API_HOST}${process.env.API_PREFIX || ""}`;

internals.queryParams = (base, options) => {
    if (!options) {
        return base;
    }

    return Object.keys(options).reduce((link, opt) => {
        if (!options[opt]) {
            return link;
        }

        return `${link}&${opt}=${options[opt]}`;
    }, base);
};

// hacky way to force app to re-request preview image only when measurements have changed
// since last view; without this, app doesn't re-request the image because the image's URL stays the same regardless
// of content of image cached in S3
internals.rev = changeable => {
    const rev = Object.keys(changeable)
        .sort((a, b) => {
            // alphabetizing is paranoid, to ensure consistency in order of measurements received and therefore rev values across
            // loads of the same croquis
            if (a > b) {
                return 1;
            }

            if (a < b) {
                return -1;
            }

            return 0;
        })
        .reduce((acc, key) => {
            if (
                typeof changeable[key] === "object" &&
                changeable[key] !== null
            ) {
                return [
                    ...acc,
                    ...Object.keys(changeable[key]).map(k => changeable[key][k])
                ];
            }

            return [...acc, changeable[key]];
        }, [])
        .join("");

    return encodeURIComponent(rev);
};

exports.previewImageLink = (model, type, authToken) => {
    const baseURL = `${internals.path}/preview/${type}/${model.id}?token=${authToken}`;
    const revInput =
        type === "purchase"
            ? Object.assign({}, model.measurements, {
                  downloadPackage: model.downloadPackage.name
              })
            : model.measurements;
    return internals.queryParams(baseURL, { rev: internals.rev(revInput) });
};

exports.downloadImageLink = (id, authToken, options) => {
    const baseURL = `${internals.path}/image/${id}?token=${authToken}`;
    return internals.queryParams(baseURL, options);
};

exports.downloadPdfLink = (id, authToken, options) => {
    const baseURL = `${internals.path}/pdf/${id}?token=${authToken}`;
    return internals.queryParams(baseURL, options);
};



// WEBPACK FOOTER //
// ./src/utils/asset-api.js